import type { ArticleListBlock as ArticleListBlockType } from '@/shared/types/blocks';
import { ArticleBlock } from './ArticleBlock';

type ArticleListBlockProps = Omit<ArticleListBlockType, 'type' | 'id'>;

/**
 * ArticleListBlock - 기사 목록
 *
 * 여러 기사를 목록 형태로 표시합니다.
 */
export function ArticleListBlock({ articles }: ArticleListBlockProps) {
  return (
    <div className="flex flex-col" style={{ gap: '48px' }}>
      {articles.map((article) => (
        <ArticleBlock
          key={article.id}
          title={article.title}
          summary={article.summary}
          tags={article.tags}
          date={article.date}
          sourceUrl={article.sourceUrl}
        />
      ))}
    </div>
  );
}
